<template>
    <div>
        <v-tooltip bottom>
            <template v-slot:activator="{ on: tooltip }">
                <v-btn v-if="mode==0 && (bank == null || bank.bankId == -1)" class="mr-1" small color="primary" v-on="tooltip" dark @click="chooseBank">
                    <v-icon>mdi-plus</v-icon>
                </v-btn>
                <v-btn v-else class="mr-1" small color="primary" dark v-on="{...tooltip}"
                    v-on:click="() => dialog =! dialog"
                >
                    <v-icon>{{`${ (mode === 0) ? 'mdi-plus' : 'mdi-pencil-outline' }`}}</v-icon>
                </v-btn>        
            </template>
            <span>{{ `${ (mode === 0) ? $t('referenceBooks.products.Create') : $t('referenceBooks.products.Edit')}` }}</span>
        </v-tooltip>
        <DragForm
            v-model="dialog"
        >
            <v-card width="800">
                <v-card-title>
                    <span class="headline">{{ `${ (mode === 0) ? $t('referenceBooks.products.Create') : $t('referenceBooks.products.Edit')}` }}</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                <v-text-field 
                                    v-model="currentProduct.bankName" 
                                    :disabled="true"
                                    :label="$t('referenceBooks.banks.Bank') + '*'"
                                    required
                                />
                            </v-col>

                            <v-col cols="12" sm="12" md="12">
                                <v-text-field v-model="currentProduct.productName" 
                                    :label="$t('referenceBooks.products.Name') + '*'"
                                    :error-messages="productErrorMessage"
                                    v-on:blur="() => { this.productWasBlurred = true }"
                                    required
                                />
                            </v-col>

                            <v-col cols="12" sm="12" md="12">
                                <v-text-field 
                                    v-model="currentProduct.link" 
                                    :label="$t('referenceBooks.products.Link') + '*'"                                
                                    :error-messages="linkErrorMessage"
                                    v-on:blur="() => { this.linkWasBlurred = true }"
                                ></v-text-field>
                            </v-col>
                            
                            <v-col cols="12" sm="12" md="12">
                                <v-text-field 
                                    v-model="currentProduct.alias" 
                                    :label="$t('referenceBooks.products.Alias') + '*'" 
                                    required
                                    :error-messages="aliasErrorMessage"
                                    v-on:blur="() => { this.aliasWasBlurred = true }"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                    <small>*{{$t('referenceBooks.requiredFields')}}</small>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialog = false">{{$t('Close')}}</v-btn>
                    <v-btn v-if="mode===0" color="blue darken-1" text @click="createProduct">{{$t('Create')}}</v-btn>
                    <v-btn v-else color="blue darken-1" text @click="saveProduct">{{$t('Save')}}</v-btn>
                </v-card-actions>
            </v-card>
        </DragForm>
    </div>
</template>

<script>
import Vue from 'vue';
import {notifyError, notifySuccess} from '@/services/notifications';
import DragForm from '@/components/Forms/DragForm.vue';
export default {
  components: {
    DragForm,
  },
  name: 'ProductDialog',
  props: {
    mode: {
      type: Number,
      defaultItem: 0
    },
    bank: {
      type: Object,
      default: null,
    },            
    product: {
      type: Object,
      default: null,
    }
  },
  data(){
    return {
      currentProduct: {
        productName: '',
        bankId: -1,
        bankName: '',
        link: '',
        alias: '',
      },
      dialog: false,

      busyValues:{
        'Name': [],
        'Alias': [],
        'Link' : [],
      },
      bankWasBlurred: false,
      productWasBlurred: false,
      linkWasBlurred: false,
      aliasWasBlurred: false,
      executeButtonClick: false,
    };
  },
  computed:{                
    propertiesResponse() {
      return { 
        'Name' : this.$t('referenceBooks.products.Name'),
        'Link' : this.$t('referenceBooks.products.Link'),
        'Alias' : this.$t('referenceBooks.products.Alias')
      };
    },
    bankErrorMessage(){
      if (this.currentProduct.bankId < 1)
        return this.$t('validations.notEmpty');

      return '';
    },
    aliasErrorMessage(){
      const name = this.currentProduct.alias;
      const check = this.executeButtonClick || 
                            this.aliasWasBlurred ||
                            name != null && name.length != 0;
                            
      if (!check)
        return '';

      return this.checkText(name, 'Alias');
    },
    productErrorMessage(){
      const name = this.currentProduct.productName;
      const check = this.executeButtonClick || 
                            this.productWasBlurred ||
                            name != null && name.length != 0;
                            
      if (!check)
        return '';

      return this.checkText(name, 'Name');
    },
    linkErrorMessage(){
      const name = this.currentProduct.link;
      const check = this.executeButtonClick || 
                            this.linkWasBlurred ||
                            name != null && name.length != 0;
                            
      if (!check)
        return '';

      return this.checkText(name, 'Link');
    }
  },
  watch: {
    dialog(flag){
      if(flag)
        if(this.mode === 0)
          this.loadModeNull();
        else
          this.loadModeOne();
      else
        this.clear();
    }
  },
  methods: {
    loadModeNull(){
      if (this.bank != null){
        this.currentProduct.bankId = this.bank.bankId;
        this.currentProduct.bankName = this.bank.bankName;
      }
    },
    loadModeOne(){
      if(this.product != null){
        Object.assign(this.currentProduct, this.product);
      }
    },
    getBank(id){
      this.$axios.banks.getById(id)
        .then(response => response.data)
        .then(json => this.bank = json)
        .catch(error => console.error(error));
    },
    getBanks(){
      this.$axios.banks.get()
        .then(response => response.data)
        .then(json => this.banks = json)
        .catch(error => console.error(error));
    },
    getProduct(){
      this.$axios.products.getById(this.productId)
        .then(response => response.data)
        .then(json => this.currentProduct = json[0])
        .catch(error => console.error(error));
    },            
    chooseBank(){
      this.showMessage(this.$t('Error'), this.$t('referenceBooks.banks.ChooseSomeBank'), 'error');
    },
    checkFields(){
      let result = true;
      let errors = this.checkText(this.currentProduct.productName, 'Name');

      if (errors != null && errors != ''){
        this.showMessage(`${this.$t('ErrorInField')}: ${this.$t('referenceBooks.products.Name')}`, errors, 'error');
        result = false;
      }

      errors = this.checkText(this.currentProduct.link, 'Link');

      if (errors != null && errors != ''){
        this.showMessage(`${this.$t('ErrorInField')}: ${this.$t('referenceBooks.Link')}`, errors, 'error');
        result = false;
      }

      errors = this.checkText(this.currentProduct.alias, 'Alias');

      if (errors != null && errors != ''){
        this.showMessage(`${this.$t('ErrorInField')}: ${this.$t('referenceBooks.Alias')}`, errors, 'error');
        result = false;
      }

      return result;
    },
    checkText(value, ind = null){
      if (value == null || value.length == 0) 
        return this.$t('validations.notEmpty');
                
      if(ind != null){
        if(this.busyValues[ind] != null && this.busyValues[ind].length != 0)
          if (this.busyValues[ind].indexOf(value, 0) != -1)
            return this.$t('errorsMessages.BusyName');
      }

      return '';
    },
    clear(){
      this.bankWasBlurred = false;
      this.productWasBlurred = false;
      this.linkWasBlurred = false;
      this.aliasWasBlurred = false;
      this.executeButtonClick = false;
                
      this.busyValues = {
        'Name': [],
        'Alias': [],
        'Link' : [],
      },

      this.currentProduct = {
        productName: '',
        bankId: -1,
        bankName: '',
        link: '',
        alias: '',
      };
    },
    catchErrors(error, errorHeader = ''){
      const status = error.response.status;
      const data = [error.response.data];

      if (status === 400 || status === 401){
        for(let i = 0; i < data.length; i++)
          this.handlingError(data[i], errorHeader, error);
      }
      else{
        this.onUnknownError(error);
      }
    },
    handlingError(data, errorHeader, error){
      switch(data.errorType){
      case 'IS_BUSY':
        this.onBusy(data.property, data.value);
        break;
      case 'NO_RIGHTS':
        this.onNoRigths(errorHeader);
        break;
      default:
        this.onUnknownError('error', error);
        break;
      }
    },
    onBusy(property, value){
      this.busyValues[property].push(value);
      const errorInField = `${this.$t('ErrorInField')}: ${this.propertiesResponse[property]}`;

      this.showMessage(errorInField, this.$t('errorsMessages.BusyName'), 'error'); 
    },
    onNoRigths(errorHeader = ''){
      this.showMessage(
        `${errorHeader === '' ? this.$t('Error') : errorHeader}`,
        this.$t('errorsMessages.NoRights'),
        'error'
      );
    },
    onUnknownError(error){
      this.$emit('error', error);
    },
    createProduct(){
      this.executeButtonClick = true;

      if (!this.checkFields())
        return;
                    
      const name = this.currentProduct.productName;

      this.$axios.products.post(
        {
          ...this.currentProduct
        }
      )
        .then(response => {
          if (response.status == 200){
            const id = response.data;
            notifySuccess('', this.$t('Messages.ProductWasCreated', [this.currentProduct.productName]));
            this.$emit('created', response.status, name, id);
            this.dialog = false;
          }
        })
        .catch(error => {
          console.error(error);
                        
          notifyError('', this.$t('Messages.ErrorOccuredWhileCreatingProduct', [this.currentProduct.productName]));
          this.catchErrors(error);
        });
    },
    saveProduct(){
      this.executeButtonClick = true;

      if (!this.checkFields())
        return;

      this.$axios.products.put(this.currentProduct.productId, this.currentProduct)
        .then(response => {
          notifySuccess('', this.$t('Messages.ProductWasEdited', [this.currentProduct.productName]));
          this.$emit('saved', response.status, this.currentProduct);
          this.dialog = false;
        })
        .catch(error => {
          console.error(error);
                        
          notifyError('', this.$t('Messages.ErrorOccuredWhileEditingProduct', [this.currentProduct.productName]));
          this.catchErrors(error);
        });
    },            
    showMessage(title, text, type = ''){
      Vue.notify({
        group: 'notif',
        title: title,
        text: text,
        type: type,
      });
    },
  },
  async mounted(){
  }

};
</script>